module.exports = __webpack_public_path__ + "static/assets/22d624982c4fd650656f3396eae16f95.svg";